import { fetchJsonResponse } from '@/ai/api'
import { buildFieldExampleDataPrompt } from '@/ai/prompts'

export const generateFieldExampleData = async ({
  aiVersion,
  entity,
  field,
  abortController
}) => {
  if (!aiVersion) {
    return null
  }

  const messages = buildFieldExampleDataPrompt({ entity, field })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'entities',
    aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
